import { render, staticRenderFns } from "./KeratoscopyForm.vue?vue&type=template&id=4e221ba3"
import script from "./KeratoscopyForm.vue?vue&type=script&lang=js"
export * from "./KeratoscopyForm.vue?vue&type=script&lang=js"
import style0 from "./KeratoscopyForm.vue?vue&type=style&index=0&id=4e221ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports